import { useMemo } from "react";

import { useSessionContext } from "../AuthModule/SessionContext";
import postalCodesCA from "./postalCodesCA.json";
import postalCodesFL from "./postalCodesFL.json";
import avisbudget from "@/assets/banners/Logos/Avis.png";
import disneyworld from "@/assets/banners/Logos/Disney World.png";
import disneyland from "@/assets/banners/Logos/Disneyland.png";
import cruises from "@/assets/banners/Logos/perkspot-cruises-rgb-vertical.png";
import ticketsattractions from "@/assets/banners/Logos/Tickets and Attractions.png";
import universalstudioshollywood from "@/assets/banners/Logos/Universal Hollywood.png";
import universalstudiosflorida from "@/assets/banners/Logos/Universal Orlando.png";
import { matchEligibility } from "@/utils/banners";

export interface MerchandisingOffer {
  image: string;
  link: string;
  description: string;
  state?: string;
  eligibilityPayloadMapping: string;
}

const MERCHANDISING_OFFERS: MerchandisingOffer[] = [
  {
    image: disneyland,
    link: "https://anything.perkspot.com/pages/disneyland",
    description:
      "Up to $40 off per person on 2-5 day visits to the <i>Disneyland</i>® Resort.",
    state: "CA",
    eligibilityPayloadMapping: "Merchants - 51264",
  },
  {
    image: disneyworld,
    link: "https://anything.perkspot.com/pages/walt-disney",
    description:
      "Save up to $80 per person on <i>Walt Disney World</i>® Resort multi-day tickets.",
    state: "FL",
    eligibilityPayloadMapping: "Merchants - 49323",
  },
  {
    image: universalstudioshollywood,
    link: "https://anything.perkspot.com/pages/universal-studios-hollywood",
    description:
      "Picture your best day ever at Universal Studios Hollywood at the best price.",
    state: "CA",
    eligibilityPayloadMapping: "Merchants - 48253",
  },
  {
    image: universalstudiosflorida,
    link: "https://anything.perkspot.com/pages/universal-studios-florida",
    description:
      "Get up to $65 off per person on Multi-Day Visits to Universal Orlando Resort.",
    state: "FL",
    eligibilityPayloadMapping: "Merchants - 51969",
  },
  {
    image: avisbudget,
    link: "https://anything.perkspot.com/pages/avis-budget-guide",
    description:
      "Get where you're going for less with exclusive deals on rental cars.",
    eligibilityPayloadMapping: "Categories - 127",
  },
  {
    image: ticketsattractions,
    link: "https://anything.perkspot.com/tickets-attractions",
    description: "Save on theme parks, aquariums, museums, and more.",
    eligibilityPayloadMapping: "Categories - 15",
  },
  {
    image: cruises,
    link: "https://anything.perkspot.com/category/128",
    description: "Set sail with cruise deals you won't find elsewhere.",
    eligibilityPayloadMapping: "Categories - 128",
  },
];

export const useMerchandising = (state?: string, postalCode?: string) => {
  const { sessionInfo } = useSessionContext();
  const userDetails = sessionInfo?.userDetails;

  return useMemo(
    () =>
      MERCHANDISING_OFFERS.filter((offer) => {
        if (offer.state && offer.state !== state) {
          return false;
        }
        if (
          offer.state === "CA" &&
          postalCode &&
          !postalCodesCA.includes(postalCode)
        ) {
          return false;
        }
        if (
          offer.state === "FL" &&
          postalCode &&
          !postalCodesFL.includes(postalCode)
        ) {
          return false;
        }
        return matchEligibility(userDetails, offer.eligibilityPayloadMapping);
      }),
    [state, postalCode, userDetails]
  );
};
